module.exports = __webpack_public_path__ + "9838689a66abb18dde1b87e204bf03c1.webp";